import { userConstant } from '../constants';

export const user = (state = {
    isLoggedIn: false,
    errorMessage: '',
    userAuthInfo: {}
}, action) => {
    switch (action.type) {
        case userConstant.USER_LOGIN:
            return {
                ...state,
                isLoggedIn: action.payload.isLoggedIn,
                errorMessage: action.payload.errorMessage
            }
        case userConstant.USER_AUTHENTICATION:
            return {
                ...state,
                isLoggedIn: action.payload.isLoggedIn,
                userAuthInfo: {
                    isAdmin: action.payload.isAdmin,
                    subject: action.payload.subject,
                    startDate: action.payload.startDate,
                    endDate: action.payload.endDate,
                    expertRating: action.payload.expertRating
                }
            }
        // case userConstant.USER_REGISTER:
        //     return {
        //         ...state,
        //     }
        default:
            return state
    }
}